// this is autogenerated file, see scripts/version-update.js
export const VERSION = '0.41.0';
